import Stack from '@mui/material/Stack';
import { Rnd } from 'react-rnd';
import Dimensions from './utilities/dimensions';
import HeightIcon from '@mui/icons-material/Height';

interface ComponentProps {
  dataURL: string;
  filename: string;
  dimensions: Dimensions;
  maxWidth?: number;
  onScaling: (width: number, height: number) => void;
}

export default ({
  dataURL,
  filename,
  dimensions,
  maxWidth,
  onScaling
}: ComponentProps) => {
  if (!dataURL) return null;

  return (
    <Stack sx={{ ...dimensions }}>
      <Rnd
        alt={filename}
        style={{
          backgroundImage: `url(${dataURL})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain'
        }}
        size={{ ...dimensions }}
        lockAspectRatio={true}
        disableDragging={true}
        onResize={(_e, _direction, ref) => {
          onScaling(ref.offsetWidth, ref.offsetHeight);
        }}
        maxWidth={maxWidth}
        enableResizing={{
          bottom: true,
          bottomLeft: false,
          bottomRight: true,
          left: false,
          right: true,
          top: false,
          topLeft: false,
          topRight: false
        }}
        resizeHandleComponent={{
          bottom: (
            <HeightIcon
              fontSize="small"
              sx={{ marginTop: '-8px', opacity: 0.2 }}
            />
          ),
          bottomRight: (
            <HeightIcon
              fontSize="small"
              sx={{ transform: 'rotate(135deg)', margin: '-4px', opacity: 0.2 }}
            />
          ),
          right: (
            <HeightIcon
              fontSize="small"
              sx={{
                transform: 'rotate(90deg)',
                marginLeft: '-8px',
                opacity: 0.2
              }}
            />
          )
        }}
      ></Rnd>
    </Stack>
  );
};
